import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { renderDate, renderPriceDecimalColumn, renderStatusBadge } from 'components/lists/functions/renderListColumn';
import { useSettings } from 'services/settings/SettingsContext';

const BillingInvoiceList: React.FC = () => {
    const { userLocale } = useSettings();

    // Specify the columns of this list
    const columns: ListColumnType[] = [
        { 
            width: '2fr', 
            field: 'filename', 
            label: 'attachment.general.name_label',
            disableOrdering: true,
        },
        { 
            width: '1fr', 
            field: 'invoice_date', 
            label: 'invoice.general.date_label',
            disableOrdering: true, 
            render: (_, row) => renderDate(row.invoice_date, userLocale) 
        },
        { 
            width: '1fr', 
            field: 'amount', 
            label: 'invoice.general.amount_label', 
            disableOrdering: true,
            render: (_, row) => renderPriceDecimalColumn(row.amount, row.currency, userLocale) 
        },
        { 
            width: '144px', 
            field: 'status', 
            label: 'invoice.general.status_label', 
            disableOrdering: true,
            render: (_, row) => renderStatusBadge(row.status) 
        }
    ];

    return (
        <div className='detail-list'>
            <AbstractList
                query={{
                    endpoint: 'get_billing_invoice_list',
                    object: 'invoice'
                }}
                objectName='invoice.general.object_name'
                columns={columns}
                showSearch={false}
                isPaginated={true}
                showAddButton={false}
                onRowClick='attachment'
            />
        </div>
    );
};

export default BillingInvoiceList;